import React from "react";
// import { MynauiSearch, SolarSortByTimeLinear } from "../ExamIntermediate";
import { EpRight } from "../../../components/college-details/components/CoursesFeesTab";

export interface FilterOption {
  name: string;
  key: string;
  count?: number;
}

export interface FilterCategory {
  categoryKey: string;
  categoryName?: string;
  options: FilterOption[];
}
interface SelectedFilters {
  [key: string]: string[];
}
interface Props {
  isMobileFilterOpen: boolean;
  filters: FilterCategory[];
  selectedFilters: SelectedFilters;
  setSelectedFilters: React.Dispatch<React.SetStateAction<SelectedFilters>>;
  setSearchParams: (nextInit: URLSearchParams) => void;
  searchStates: Record<string, string>;
  setSearchStates: React.Dispatch<React.SetStateAction<Record<string, string>>>;
  showMoreStates: Record<string, boolean>;
  setShowMoreStates: React.Dispatch<
    React.SetStateAction<Record<string, boolean>>
  >;
  activeMobileCategory: string;
  setActiveMobileCategory: React.Dispatch<React.SetStateAction<string>>;
  setIsMobileFilterOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleFilterChange: (category: string, optionKey: string) => void;
}

const MobileFilterSidebar: React.FC<Props> = ({
  isMobileFilterOpen,
  filters,
  selectedFilters,
  searchStates,
  setSearchStates,
  showMoreStates,
  setShowMoreStates,
  activeMobileCategory,
  setActiveMobileCategory,
  setSelectedFilters,
  setSearchParams,
  handleFilterChange,
  setIsMobileFilterOpen,
}) => {
  if (!isMobileFilterOpen) return null;

  return (
    <aside className="fixed inset-0 z-[1111] bg-white flex flex-col lg:hidden">
      {/* Header */}
      <div className="flex justify-between items-center px-4 py-3  bg-[#1E32A0] gap-3 text-white">
        <h3 className="text-base font-semibold flex items-center gap-1">
          <button
            className="text-white text-sm"
            onClick={() => {
              setSelectedFilters({});
              setSearchParams(new URLSearchParams());
              setIsMobileFilterOpen(false);
            }}
          >
            <EpRight className="rotate-180 w-5 h-5" />
          </button>{" "}
          Filter By
        </h3>
        <button
          className="text-white text-sm font-medium"
          onClick={() => {
            setSelectedFilters({});
            setSearchParams(new URLSearchParams());
          }}
        >
          Clear All
        </button>
      </div>

      <div className="flex flex-1 overflow-hidden">
        {/* Left Tabs */}
        <div className="w-[50%] bg-[#f2f2f2] overflow-y-auto">
          {filters.map((category) => (
            <button
              key={category.categoryKey}
              onClick={() => setActiveMobileCategory(category.categoryKey)}
              className={`w-full text-left px-3 py-2 text-sm font-medium ${
                activeMobileCategory === category.categoryKey
                  ? "text-[#1E32A0] border-l-4 border-[#00B489] bg-white"
                  : "text-black"
              }`}
            >
              {category.categoryName}
            </button>
          ))}
        </div>

        {/* Right Filter Content */}
        <div className="w-[50%] p-2 overflow-y-auto">
          {filters
            .filter(
              (c) =>
                c.categoryKey !== "sortBy" &&
                c.categoryKey === activeMobileCategory
            )
            .map((category) => {
              const searchText = searchStates[category.categoryKey] || "";
              const showAll = showMoreStates[category.categoryKey] || false;
              const filteredOptions = category.options.filter((opt) =>
                opt.name.toLowerCase().includes(searchText.toLowerCase())
              );
              const visibleOptions = showAll
                ? filteredOptions
                : filteredOptions.slice(0, 10);

              return (
                <div key={category.categoryKey}>
                  {/* Search Input */}
                  <div className="relative mb-4">
                    <input
                      type="text"
                      placeholder={`Search by ${category.categoryName}`}
                      value={searchText}
                      onChange={(e) =>
                        setSearchStates((prev) => ({
                          ...prev,
                          [category.categoryKey]: e.target.value,
                        }))
                      }
                      className="w-full border rounded pl-3 pr-5 py-2 text-sm"
                    />
                    <div className="absolute right-1 top-2.5 text-[#1E32A0]">
                      {/* <MynauiSearch className="w-4 h-4" /> */}
                    </div>
                  </div>

                  {/* Options */}
                  <ul className="space-y-3">
                    {visibleOptions.map((option) => (
                      <li key={option.key} className="flex items-center gap-2">
                        <input
                          type="checkbox"
                          checked={
                            selectedFilters[category.categoryKey]?.includes(
                              option.key
                            ) || false
                          }
                          onChange={() =>
                            handleFilterChange(category.categoryKey, option.key)
                          }
                          className="accent-[#00B489] w-5 h-5"
                        />
                        <label className="text-sm">
                          {option.name} ({option.count})
                        </label>
                      </li>
                    ))}
                  </ul>

                  {filteredOptions.length > 10 && (
                    <button
                      className="mt-3 text-[#2ABCA7] text-sm"
                      onClick={() =>
                        setShowMoreStates((prev) => ({
                          ...prev,
                          [category.categoryKey]: !showAll,
                        }))
                      }
                    >
                      {showAll ? "Show less" : "Show more"}
                    </button>
                  )}
                </div>
              );
            })}
        </div>
      </div>

      {/* Bottom Action Bar */}
      <div className="border-t p-3 flex justify-end">
        <button
          onClick={() => setIsMobileFilterOpen(false)}
          className="bg-[#1E32A0] text-white rounded px-6 py-2 text-sm flex items-center gap-1"
        >
          <span className="material-icons">Check</span> Apply
        </button>
      </div>
    </aside>
  );
};

export default MobileFilterSidebar;
